import type { Agent, Persisted } from '@tunasong/schemas'
import { MenuItem } from '@tunasong/ui-lib'
import cn from 'classnames'
import type { FC } from 'react'
import styles from './agent-pill.module.css'
import type { AgentRosterRow } from './use-agent-roster.js'

export const AgentInitials: FC<{ row: AgentRosterRow; className?: string }> = ({ row, className }) => (
  <span className={cn(styles.initials, className)} style={{ backgroundColor: row.color }} aria-hidden="true">
    {row.initials}
  </span>
)

export interface AgentRosterMenuItemProps {
  row: AgentRosterRow
  onSelect: (agent: Persisted<Agent>) => void
}

/** One agent in a menu: initials, name and spoken status ("Chord Advisor, unread") */
export const AgentRosterMenuItem: FC<AgentRosterMenuItemProps> = ({ row, onSelect }) => (
  <MenuItem aria-label={[row.name, ...row.status].join(', ')} onClick={() => onSelect(row.agent)}>
    <AgentInitials row={row} />
    <span className={styles.itemName}>{row.name}</span>
    {row.status.length > 0 ? <span className={styles.itemStatus}>{row.status.join(', ')}</span> : null}
  </MenuItem>
)
